/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Add_Card_DescriptionInputs */

const en_plan_add_card_description = /** @type {(inputs: Plan_Add_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is charged today. We'll charge this card when your plan renews.`)
};

const es_plan_add_card_description = /** @type {(inputs: Plan_Add_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy no se cobra nada. Cobraremos esta tarjeta cuando se renueve tu plan.`)
};

/**
* | output |
* | --- |
* | "Nothing is charged today. We'll charge this card when your plan renews." |
*
* @param {Plan_Add_Card_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_add_card_description = /** @type {((inputs?: Plan_Add_Card_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Add_Card_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_add_card_description(inputs)
	return en_plan_add_card_description(inputs)
});